import { t } from 'i18next';

export function ResponsiveMenuTitle({ title, shortTitle }: { title: string; shortTitle: string }) {
  return (
    <>
      <span className="rio-menu-title--full">{t(title)}</span>
      <span className="rio-menu-title--short">{t(shortTitle)}</span>
    </>
  );
}
